import axios from './axiosConfig'; 

const API_URL = '/auth/';

const login = async (username, password) => {
    const response = await axios.post(API_URL + 'login', {username, password});
    if(response.data.token){
        localStorage.setItem('token', response.data.token);
        const payload = response.data.token.split('.')[1]
        const base64 = payload
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const paddedBase64 =
            base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const binaryString = atob(paddedBase64);

        const bytes = Uint8Array.from(
            binaryString,
            char => char.charCodeAt(0)
        );
        const decodedString = new TextDecoder('utf-8').decode(bytes);
        const decodedToken = JSON.parse(decodedString);
        localStorage.setItem('user', JSON.stringify(decodedToken));
    }
    return response.data;
};

const logout = () => { // OK
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

const getCurrentUser = () => { // OK
    return JSON.parse(localStorage.getItem('user'));
};

export default {
    login,
    logout,
    getCurrentUser
   
};